export default __webpack_public_path__ + "static/SSSpyView_screenshot-3@2x-7804e425cd45f82caa1073c6492e9aa7.jpg";